import actions from './actions';

const initState = {
  isLoading: false,
  types: [],
};

export default function reducer(state = initState, { type, payload }) {
  switch (type) {
    case actions.LOAD_TYPES:
      return {
        ...state,
        isLoading: true,
      };
    case actions.LOAD_TYPES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        types: payload.data,
      };
    case actions.LOAD_TYPES_ERROR:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
}
